// services/partnersService.js - сервис для работы с реальными данными партнеров

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class PartnersService {
    constructor() {
        this.token = localStorage.getItem('auth_token');
    }

    // Получение заголовков для запросов
    getHeaders() {
        const headers = {
            'Content-Type': 'application/json',
        };

        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        return headers;
    }

    // Обновление токена
    updateToken() {
        this.token = localStorage.getItem('auth_token');
    }

    // Получение списка партнеров
    async getPartners(params = {}) {
        try {
            this.updateToken();

            const queryParams = new URLSearchParams();

            // Добавляем параметры фильтрации и пагинации
            if (params.partner_id) queryParams.append('partner_id', params.partner_id);
            if (params.search) queryParams.append('search', params.search);
            if (params.status && params.status !== 'all') queryParams.append('status', params.status);
            if (params.level && params.level !== 'all') queryParams.append('level', params.level);
            if (params.sort_by) queryParams.append('sort_by', params.sort_by);
            if (params.sort_direction) queryParams.append('sort_direction', params.sort_direction);
            if (params.per_page) queryParams.append('per_page', params.per_page);

            // ИСПРАВЛЕНО: добавляем правильный параметр page
            if (params.page) queryParams.append('page', params.page);

            const url = `${API_BASE_URL}/partners${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

            console.log('Запрос к API:', url); // Для отладки

            const response = await fetch(url, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения списка партнеров'
            };
        } catch (error) {
            console.error('Get partners error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Получение информации о конкретном партнере
    async getPartner(partnerId) {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/partners/${partnerId}`, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения данных партнера'
            };
        } catch (error) {
            console.error('Get partner error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Получение генеалогического дерева
    async getGenealogy(params = {}) {
        try {
            this.updateToken();

            const queryParams = new URLSearchParams();
            if (params.depth) queryParams.append('depth', params.depth);
            if (params.partner_id) queryParams.append('partner_id', params.partner_id);

            const url = `${API_BASE_URL}/partners/genealogy/tree${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения генеалогии'
            };
        } catch (error) {
            console.error('Get genealogy error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Получение ветки генеалогического дерева (для ленивой загрузки)
    async getGenealogyBranch(params = {}) {
        try {
            this.updateToken();

            const queryParams = new URLSearchParams();
            if (params.partner_id) queryParams.append('partner_id', params.partner_id);
            if (params.depth) queryParams.append('depth', params.depth);

            const url = `${API_BASE_URL}/partners/genealogy/branch${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения ветки генеалогии'
            };
        } catch (error) {
            console.error('Get genealogy branch error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Получение статистики рефералов
    async getReferralStats() {
        try {
            this.updateToken();

            const response = await fetch(`${API_BASE_URL}/partners/referral/stats`, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                return { success: true, data: data.data };
            }

            return {
                success: false,
                message: data.message || 'Ошибка получения статистики рефералов'
            };
        } catch (error) {
            console.error('Get referral stats error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }

    // Метод для навигации по дереву генеалогии
    async navigateToPartner(partnerId, depth = 3) {
        try {
            const response = await this.getGenealogy({
                partner_id: partnerId,
                depth: depth
            });

            return response;
        } catch (error) {
            console.error('Navigate to partner error:', error);
            return {
                success: false,
                message: 'Ошибка навигации по структуре'
            };
        }
    }

    // Метод для получения расширенной информации о партнере для дерева
    async getPartnerTreeInfo(partnerId) {
        try {
            const [partnerResponse, genealogyResponse] = await Promise.all([
                this.getPartner(partnerId),
                this.getGenealogy({ partner_id: partnerId, depth: 2 })
            ]);

            if (partnerResponse.success && genealogyResponse.success) {
                return {
                    success: true,
                    data: {
                        partner: partnerResponse.data,
                        tree: genealogyResponse.data
                    }
                };
            }

            return {
                success: false,
                message: 'Ошибка получения информации о партнере'
            };
        } catch (error) {
            console.error('Get partner tree info error:', error);
            return {
                success: false,
                message: 'Ошибка сети. Попробуйте позже.'
            };
        }
    }
}

export const partnersService = new PartnersService();
